import { FormattedExecutionResult } from 'graphql';
import get from 'ts-get';

import { useRutilusMutation } from '../../api/graphql/useRutilusMutation';
import { CreateDirectUploadUrl, ImageUploadAttributes } from '../../interfaces/graphql';
import { createDirectUploadUrl } from '../../mutations/rutilus/Uploads';
import { uploadToS3 } from '../files';

const isCreateDirectUploadUrlResult = (
  res: void | FormattedExecutionResult<CreateDirectUploadUrl>,
): res is FormattedExecutionResult<CreateDirectUploadUrl> =>
  (res as FormattedExecutionResult<CreateDirectUploadUrl>).data !== undefined;

// TODO This hook can also be used for files other than images. We should rename it to useFileUpload.
// the type of uploadAttributes should be changed to FileUploadAttributes but this is not implemented in the backend yet.
export type UploadImage = (image: any, uploadAttributes: ImageUploadAttributes) => Promise<string>;
export function useImageUpload(): UploadImage {
  const [getDirectUploadUrl] = useRutilusMutation<CreateDirectUploadUrl>(createDirectUploadUrl);

  return async (image: any, uploadAttributes: ImageUploadAttributes): Promise<string> =>
    getDirectUploadUrl({
      variables: { input: { attributes: uploadAttributes } },
    }).then(async result => {
      if (!isCreateDirectUploadUrlResult(result)) {
        throw new Error('Required values not returned from createDirectUploadUrl');
      }
      const { data } = result;

      const url = get(data, d => d.createDirectUploadUrl.directUploadUrl.url, null);
      const headers = get(data, d => d.createDirectUploadUrl.directUploadUrl.headers, null);
      const signedId = get(data, d => d.createDirectUploadUrl.directUploadUrl.signedId, null);
      if (!url || !headers || !signedId) {
        throw new Error('Required values not returned from createDirectUploadUrl');
      }
      return uploadToS3(url, image, headers).then(() => signedId);
    });
}
